module.exports = __webpack_public_path__ + "img/icon_genius.e37b096.png";